import { render } from "./EventActive2.vue?vue&type=template&id=d6fc591e&scoped=true"
import script from "./EventActive2.vue?vue&type=script&lang=js"
export * from "./EventActive2.vue?vue&type=script&lang=js"

import "./EventActive2.vue?vue&type=style&index=0&id=d6fc591e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fc591e"]])

export default __exports__